@import '@hevoio/hevo-ui-toolkit/styles/variables';

.dialogContainer {
  align-items: flex-start;
}

.dialogHeader {
  padding: $spacer * 1.5 $spacer * 1.5 $spacer;
}

.dialogBody {
  padding: $spacer * 1.25;
}

.dialogFooter {
  padding: $spacer * 1.25 $spacer * 1.5 $spacer * 1.5;
}

.dialogContent {
  max-width: 100%;
}

.closeDialogBtn {
  position: absolute !important;
  top: $spacer * 0.5;
  right: $spacer * 0.5;
}

.schemaDropdown {
  width: 248px !important;
}

.inputBox {
  width: 164px !important;
}

.frequencyForm {
  max-width: 490px;
}

.cronTimeList {
  max-height: 220px;
  max-width: 490px;
  overflow: auto;
}

.schemaDropdown {
  width: 248px !important;
}

.multiCronButton {
  align-self: center;
  max-height: fit-content;
}

.w50 {
  width: 50% !important;
}
